import type { Timestamp } from 'firebase/firestore';

/**
 * Subscription status from Stripe
 */
export type SubscriptionStatus =
  | 'active'
  | 'canceled'
  | 'past_due'
  | 'unpaid'
  | 'trialing'
  | 'incomplete';

/**
 * User subscription data stored in Firestore
 */
export type UserSubscription = {
  stripeCustomerId?: string;
  subscriptionId?: string;
  subscriptionStatus?: SubscriptionStatus;
  currentPeriodEnd?: Timestamp;
  cancelAtPeriodEnd?: boolean;
};

/**
 * Subscription data returned by useSubscription hook
 */
export type SubscriptionData = {
  plan: 'free' | 'pro';
  subscriptionStatus?: SubscriptionStatus;
  currentPeriodEnd?: Date;
  cancelAtPeriodEnd?: boolean;
  stripeCustomerId?: string;
  isLoading: boolean;
};

/**
 * Pro plan pricing
 */
export const PRO_PRICING = {
  monthly: 5.95,
  annual: 71.4, // $5.95 × 12
  currency: 'USD',
  nzGstRate: 0.15,
} as const;

/**
 * Format price for display
 */
export const formatPrice = (amount: number, currency = 'USD'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount);
};
